module.exports = __webpack_public_path__ + "img/level_up.6448030d.jpg";